import React from 'react';
import { formatTicketPriority, formatTicketStatus, toJsDate } from '../utils/ticketFormatters';

function statusBadgeClass(status) {
  const classes = ['st-badge', 'st-badgeStatus'];
  if (status === 'open') classes.push('st-badgeOpen');
  if (status === 'in_progress') classes.push('st-badgeInProgress');
  if (status === 'resolved') classes.push('st-badgeResolved');
  if (status === 'closed') classes.push('st-badgeClosed');
  return classes.join(' ');
}

function priorityBadgeClass(priority) {
  const classes = ['st-badge', 'st-badgePriority'];
  if (priority === 'low') classes.push('st-badgeLow');
  if (priority === 'normal') classes.push('st-badgeNormal');
  if (priority === 'high') classes.push('st-badgeHigh');
  if (priority === 'urgent') classes.push('st-badgeUrgent');
  return classes.join(' ');
}

export default function SupportTicketList({ tickets, onOpenTicket }) {
  if (!tickets || tickets.length === 0) {
    return (
      <div className="st-alert">
        No tickets yet. If you need help, submit a ticket and we’ll get back to you.
      </div>
    );
  }

  return (
    <div className="st-list">
      {tickets.map((t) => {
        const dt = toJsDate(t.updatedAt || t.createdAt);
        const timeText = dt ? dt.toLocaleString() : '—';
        const ticketNumberText =
          typeof t.ticketNumber === 'number'
            ? `Ticket #${t.ticketNumber}`
            : (typeof t.ticketNumber === 'string' && t.ticketNumber.trim())
              ? `Ticket #${t.ticketNumber.trim()}`
              : `Ticket #${String(t.id || '').slice(0, 6).toUpperCase()}`;
        return (
          <div
            key={t.id}
            className="st-ticket"
            role="button"
            tabIndex={0}
            onClick={() => onOpenTicket(t)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') onOpenTicket(t);
            }}
          >
            <div className="st-ticketTop">
              <div className="st-ticketSubject">{t.subject || '(no subject)'}</div>
              <span className="st-badgeRow">
                <span className={statusBadgeClass(t.status)}>
                  {formatTicketStatus(t.status)}
                </span>
                <span className={priorityBadgeClass(t.priority)}>
                  {formatTicketPriority(t.priority)}
                </span>
              </span>
            </div>
            <div className="st-ticketMeta">
              <span>{ticketNumberText}</span>
              <span>Updated: {timeText}</span>
              {t.category ? <span>Category: {t.category}</span> : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}

